
import useAnalysisHooks, { getJobStatus, TableData } from '@/hooks/analysis.hooks';
import useHooks from '@/hooks/index.hooks';
import { GetJobStatus } from '@/interface/analysis.interface';
import { Page } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import { definitions } from '@/types/api';
import { Pagination, Table } from 'ant-design-vue';
import {
  defineComponent, reactive, toRefs, computed,
} from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    aTable: Table,
    aPagination: Pagination,
  },
  setup() {
    const { getPageOption } = useHooks();
    const analysisHooks = useAnalysisHooks();
    const router = useRouter();
    const tableData = reactive<Page & TableData>({
      tableList: [],
      tableLoading: false,
      columns: cloneDeep(analysisHooks.analysisColumns),
      /** */
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageOption: cloneDeep(getPageOption),
    });
    /** 查询列表 */
    const getList = async () => {
      tableData.tableLoading = true;
      const { pageNo, pageSize } = tableData;
      const { list, total } = await analysisHooks.listAssignHomeworkList({ pageNo, pageSize });
      Object.assign(tableData, {
        tableList: list, total, tableLoading: false,
      });
    };
    const pageMethod = reactive({
      showSizeChange: (_: unknown, size: number) => {
        tableData.pageSize = size;
        tableData.pageNo = 1;
        getList();
      },
      pageChange: (page: number) => {
        tableData.pageNo = page;
        getList();
      },
    });

    const tableMethod = reactive({
      /** 是否禁用 答题 */
      isStartDisabled: computed(() => (record: definitions['AssignHomework']) => {
        const statusName = getJobStatus(record as GetJobStatus);
        /** 时间转为状态的判断 */
        if (statusName === '未开始') return true;
        if (statusName === '已结束') return true; // true
        /** 考核模式-自己提交了，但是教师未发布成绩-不允许点 */
        if (record.assignmentModel === 1 && record.personnelStatus === 1) return true;
        return false;
      }),
      /** 开始实验 */
      gotoStart: (record: definitions['AssignHomework']) => {
        console.log(record, 'rcord');
        router.push({
          path: '/Student/analysisAnswer',
          query: {
            view: 'submit', // preview,see,submit
            jobId: record.assignmentId, // jobId这是教师端的作业id
            assignmentId: record.id, // 这是分配表的id
            assignmentModel: record.assignmentModel, // 分配模式
          },
        });
      },
      /** 是否可以点击查看 */
      isRanking: computed(() => (record: definitions['AssignHomework']) => {
        // -1 学生没做
        if (record.ranking === -1) return false;
        return true;
      }),
      /** 跳转详情页 */
      gotoInfo: (record: definitions['AssignHomework']) => {
        console.log(record, router);
        router.push({
          path: '/Student/analysisAnswer',
          query: {
            view: 'see', // preview,see,submit
            jobId: record.assignmentId, // jobId这是教师端的作业id
            assignmentId: record.id, // 这是分配表的id
            assignmentModel: record.assignmentModel, // 分配模式
          },
        });
        // reportHooks.currentReportDate.set(record.createTime || '');
        // router.push({
        //   path: `/Student/reportInfo/${record.id}`,
        // });
      },
    });

    getList();
    return {
      ...toRefs(tableData),
      ...toRefs(pageMethod),
      ...toRefs(tableMethod),
      getJobStatus,
    };
  },
});
